/* Validate email address */
export const validEmail = (email: string): boolean => {
  const pattern: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(email)
}

export const hasClass = (elem: HTMLElement, className: string): boolean => {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ')
}
